import { render, staticRenderFns } from "./AutoLoginPage.vue?vue&type=template&id=38908daa&"
import script from "./AutoLoginPage.vue?vue&type=script&lang=js&"
export * from "./AutoLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports